/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const TableCell = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    className,
    hasAILabelHeader,
    colSpan,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const tableCellClassNames = cx(className, {
    [`${prefix}--table-cell--column-slug`]: hasAILabelHeader
  });
  return /*#__PURE__*/React__default.createElement("td", _extends({
    className: tableCellClassNames ? tableCellClassNames : undefined,
    ref: ref,
    colSpan: colSpan
  }, rest), children);
});
TableCell.displayName = 'TableCell';

export { TableCell as default };
